import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "HERO_LEARNING",
  title: defineMessage({ id: "fig.learning.HERO.title", defaultMessage: `Learning` }),
  caption: defineMessage({
    id: "fig.learning.HERO.caption",
    defaultMessage: `In one out of four countries in sub-Saharan Africa, more than half of students at the end of primary school achieve below the minimum proficiency level in reading.`,
  }),
  source: defineMessage({ id: "fig.learning.HERO.source", defaultMessage: `UIS database` }),
};
